// extracted by mini-css-extract-plugin
export default {"fullWidth":"Do-z","image":"Eo-z","lazyLoadPicture":"Fo-z","lazyLoadSpinner":"Go-z","lazyLoadSpin":"Ho-z","lazyLoadImage":"Io-z","hasStyledAspectRatio":"Jo-z"};